"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMappedIconSize = exports.getButtonIconFontSize = exports.getDimensions = exports.getVariantComponent = void 0;
var styled_components_1 = require("styled-components");
var styles_1 = require("./styles");
var getPaddings = function (theme, size) {
    if (theme === 'valtra') {
        if (size === 'sm') {
            return '0 16px';
        }
        return '8px 20px';
    }
    if (size === 'sm') {
        return '0 8px';
    }
    return '8px 16px';
};
var getVariantComponent = function (variant) {
    switch (variant) {
        case 'primary':
            return styles_1.PrimaryButton;
        case 'text':
            return styles_1.TextButton;
        case 'tertiary':
            return styles_1.TertiaryButton;
        case 'secondary':
        default:
            return styles_1.SecondaryButton;
    }
};
exports.getVariantComponent = getVariantComponent;
var getDimensions = function (_a) {
    var size = _a.size, _b = _a.theme.button, height = _b.height, fontSizes = _b.fontSizes;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: ", "px;\n  font-size: ", "px;\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  height: ", "px;\n  font-size: ", "px;\n  padding: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), height[size], fontSizes[size], function (_a) {
        var theme = _a.theme;
        return getPaddings(theme.name, size);
    });
};
exports.getDimensions = getDimensions;
var buttonIconSizes = {
    lg: 32,
    md: 24,
    sm: 20,
};
var getButtonIconFontSize = function (size) {
    return buttonIconSizes[size];
};
exports.getButtonIconFontSize = getButtonIconFontSize;
var getMappedIconSize = function (size) {
    switch (size) {
        case 'lg':
            return 'l';
        case 'sm':
            return 's';
        case 'md':
            return 'm';
        default:
            return size;
    }
};
exports.getMappedIconSize = getMappedIconSize;
var templateObject_1;
